(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lca-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.lcaHomepageReady) return;
  window.lcaHomepageReady = true;
  let previousFocus = null;
  const root = document;
  function close(dialog) { dialog.close(); document.body.style.overflow = ''; previousFocus?.focus({preventScroll:true}); }
  function appSetup() {
    const banner=root.getElementById('app-banner'), link=root.getElementById('smart-app-link');
    if (!banner || !link) return;
    const android=root.querySelector('.app-store-links a[href*="play.google.com"]');
    const ios=root.querySelector('.app-store-links a[href*="apps.apple.com"]');
    const isIos=/iPad|iPhone|iPod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
    link.href=/Android/i.test(navigator.userAgent)&&android?android.href:isIos&&ios?ios.href:'#download-app';
    try { const date=Number(localStorage.getItem('lca-app-banner-dismissed')); if(date>0&&Date.now()-date<604800000&&!window.Shopify?.designMode)banner.hidden=true; } catch (_) {}
  }
  function renderSearch() {
    const input=root.getElementById('product-search'),results=root.getElementById('search-results');
    if(!input||!results)return;
    const cards=[...new Map([...root.querySelectorAll('.product-card')].map(card=>[card.dataset.handle,card])).values()];
    const matches=cards.filter(card=>card.dataset.search.includes(input.value.trim().toLowerCase())).slice(0,6);
    results.replaceChildren();
    for(const card of matches){const a=document.createElement('a');a.className='search-result';a.href=card.querySelector('.product-name a').href;const img=card.querySelector('.product-image img');if(img)a.append(img.cloneNode());const text=document.createElement('span');const name=document.createElement('strong');name.textContent=card.querySelector('.product-name').textContent;const price=document.createElement('small');price.textContent=card.querySelector('.current-price').textContent;text.append(name,price);a.append(text);results.append(a);}
  }
  root.addEventListener('click',event=>{
    const opener=event.target.closest('[data-open]');
    if(opener){const dialog=root.getElementById(opener.dataset.open);if(dialog){previousFocus=opener;dialog.showModal();document.body.style.overflow='hidden';if(dialog.id==='search-dialog'){renderSearch();root.getElementById('product-search').focus();}}return;}
    const closer=event.target.closest('[data-close],[data-close-link]');if(closer){const dialog=closer.closest('dialog');if(dialog)close(dialog);}
    if(event.target.matches('dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(event.target);}
    const dismiss=event.target.closest('#app-dismiss');if(dismiss){root.getElementById('app-banner').hidden=true;try{localStorage.setItem('lca-app-banner-dismissed',String(Date.now()));}catch(_){}root.querySelector('.brand')?.focus({preventScroll:true});}
    const filter=event.target.closest('[data-filter]');if(filter){const section=filter.closest('section');section.querySelectorAll('[data-filter]').forEach(button=>{const active=button===filter;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});const value=filter.dataset.filter;let count=0;section.querySelectorAll('.product-card').forEach(card=>{const show=value==='all'?card.dataset.bestseller==='true':value==='budget'?Number(card.dataset.price)<1000:card.dataset.categories.split(' ').includes(value);card.hidden=!show;if(show)count++;});const status=root.getElementById('filter-status');if(status)status.textContent=count+' · '+filter.textContent;}
  });
  root.addEventListener('input',event=>{if(event.target.id==='product-search')renderSearch();});
  root.addEventListener('close',event=>{if(event.target.matches('dialog')){document.body.style.overflow='';previousFocus?.focus({preventScroll:true});}},true);
  root.addEventListener('shopify:section:load',()=>{appSetup();renderSearch();});
  root.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.product-card');if(card)card.hidden=false;});
  if(document.readyState==='loading')root.addEventListener('DOMContentLoaded',appSetup);else appSetup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    root.querySelectorAll('[data-lca-campaign]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.campaign-track');
      const slides = [...section.querySelectorAll('.campaign-slide')];
      const tabs = [...section.querySelectorAll('[data-campaign-index]')];
      let active = 0, queued = false;
      function go(index, smooth = true) {
        const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
        if (!slide) return;
        track.scrollTo({left: slide.offsetLeft - slides[0].offsetLeft, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
      }
      function sync() {
        const left = track.getBoundingClientRect().left;
        let nearest = Infinity;
        slides.forEach((slide, index) => {
          const delta = Math.abs(slide.getBoundingClientRect().left - left);
          if (delta < nearest) { nearest = delta; active = index; }
        });
        tabs.forEach((tab, index) => tab.setAttribute('aria-pressed', String(index === active)));
        section.querySelectorAll('[data-campaign-step]').forEach(button => {
          button.disabled = Number(button.dataset.campaignStep) < 0 ? active === 0 : active === slides.length - 1;
        });
        queued = false;
      }
      section.addEventListener('click', event => {
        const tab = event.target.closest('[data-campaign-index]');
        const arrow = event.target.closest('[data-campaign-step]');
        if (tab) go(Number(tab.dataset.campaignIndex));
        if (arrow) go(active + Number(arrow.dataset.campaignStep));
      });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      track.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(sync); } }, {passive: true});
      section.addEventListener('shopify:block:select', event => {
        const selected = event.target.closest('.campaign-slide');
        if (selected) go(slides.indexOf(selected), false);
      });
      sync();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-home-utilities"]) return;
  try {
    
(() => {
  if (window.lcaLaunchHelpReady) return;
  window.lcaLaunchHelpReady = true;
  let previousFocus;
  document.addEventListener('click',event => {
    const container=document.getElementById('lca-home-content');
    if (!container?.contains(event.target)) return;
    const dialog=container.querySelector('#support-dialog');
    if (!dialog) return;
    if (event.target.closest('[data-open="support-dialog"]')) {previousFocus=event.target.closest('button,a');dialog.showModal();return;}
    if (event.target.closest('[data-close],[data-close-link]')) dialog.close();
  });
  document.addEventListener('close',event=>{if(event.target.id==='support-dialog')previousFocus?.focus({preventScroll:true});},true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-product-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.lcaHomepageReady) return;
  window.lcaHomepageReady = true;
  let previousFocus = null;
  const root = document;
  function close(dialog) { dialog.close(); document.body.style.overflow = ''; previousFocus?.focus({preventScroll:true}); }
  function appSetup() {
    const banner=root.getElementById('app-banner'), link=root.getElementById('smart-app-link');
    if (!banner || !link) return;
    const android=root.querySelector('.app-store-links a[href*="play.google.com"]');
    const ios=root.querySelector('.app-store-links a[href*="apps.apple.com"]');
    const isIos=/iPad|iPhone|iPod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
    link.href=/Android/i.test(navigator.userAgent)&&android?android.href:isIos&&ios?ios.href:'#download-app';
    try { const date=Number(localStorage.getItem('lca-app-banner-dismissed')); if(date>0&&Date.now()-date<604800000&&!window.Shopify?.designMode)banner.hidden=true; } catch (_) {}
  }
  function renderSearch() {
    const input=root.getElementById('product-search'),results=root.getElementById('search-results');
    if(!input||!results)return;
    const cards=[...new Map([...root.querySelectorAll('.product-card')].map(card=>[card.dataset.handle,card])).values()];
    const matches=cards.filter(card=>card.dataset.search.includes(input.value.trim().toLowerCase())).slice(0,6);
    results.replaceChildren();
    for(const card of matches){const a=document.createElement('a');a.className='search-result';a.href=card.querySelector('.product-name a').href;const img=card.querySelector('.product-image img');if(img)a.append(img.cloneNode());const text=document.createElement('span');const name=document.createElement('strong');name.textContent=card.querySelector('.product-name').textContent;const price=document.createElement('small');price.textContent=card.querySelector('.current-price').textContent;text.append(name,price);a.append(text);results.append(a);}
  }
  root.addEventListener('click',event=>{
    const opener=event.target.closest('[data-open]');
    if(opener){const dialog=root.getElementById(opener.dataset.open);if(dialog){previousFocus=opener;dialog.showModal();document.body.style.overflow='hidden';if(dialog.id==='search-dialog'){renderSearch();root.getElementById('product-search').focus();}}return;}
    const closer=event.target.closest('[data-close],[data-close-link]');if(closer){const dialog=closer.closest('dialog');if(dialog)close(dialog);}
    if(event.target.matches('dialog')){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(event.target);}
    const dismiss=event.target.closest('#app-dismiss');if(dismiss){root.getElementById('app-banner').hidden=true;try{localStorage.setItem('lca-app-banner-dismissed',String(Date.now()));}catch(_){}root.querySelector('.brand')?.focus({preventScroll:true});}
    const filter=event.target.closest('[data-filter]');if(filter){const section=filter.closest('section');section.querySelectorAll('[data-filter]').forEach(button=>{const active=button===filter;button.classList.toggle('active',active);button.setAttribute('aria-pressed',String(active));});const value=filter.dataset.filter;let count=0;section.querySelectorAll('.product-card').forEach(card=>{const show=value==='all'?card.dataset.bestseller==='true':value==='budget'?Number(card.dataset.price)<1000:card.dataset.categories.split(' ').includes(value);card.hidden=!show;if(show)count++;});const status=root.getElementById('filter-status');if(status)status.textContent=count+' · '+filter.textContent;}
  });
  root.addEventListener('input',event=>{if(event.target.id==='product-search')renderSearch();});
  root.addEventListener('close',event=>{if(event.target.matches('dialog')){document.body.style.overflow='';previousFocus?.focus({preventScroll:true});}},true);
  root.addEventListener('shopify:section:load',()=>{appSetup();renderSearch();});
  root.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.product-card');if(card)card.hidden=false;});
  if(document.readyState==='loading')root.addEventListener('DOMContentLoaded',appSetup);else appSetup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-product-main"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    root.querySelectorAll('[data-lca-product]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.pdp-image-track');
      const slides = [...track.querySelectorAll('.pdp-image-slide')];
      const thumbs = [...section.querySelectorAll('[data-gallery-target]')];
      let frame = false;
      function move(slide) {
        if (slide && slides.length) track.scrollTo({left: slide.offsetLeft - slides[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      thumbs.forEach(button => button.addEventListener('click', () => move(document.getElementById(button.dataset.galleryTarget))));
      track.addEventListener('scroll', () => {
        if (frame || !slides.length) return;
        frame = true;
        requestAnimationFrame(() => {
          const left = track.getBoundingClientRect().left;
          const nearest = slides.reduce((a,b) => Math.abs(a.getBoundingClientRect().left-left) < Math.abs(b.getBoundingClientRect().left-left) ? a : b);
          thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryTarget === nearest.id)));
          slides.forEach(slide => { if (slide !== nearest) slide.querySelectorAll('video').forEach(video => video.pause()); });
          frame = false;
        });
      }, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const active = thumbs.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        move(slides[Math.max(0,Math.min(slides.length-1,active+(event.key === 'ArrowRight' ? 1 : -1)))]);
      });
      section.addEventListener('shopify:block:select', event => move(event.target.closest('.pdp-image-slide')));

      const form = section.querySelector('.pdp-product-form');
      if (!form) return;
      const select = form.querySelector('[data-variant-select]');
      const variants = [...select.options].map(option => ({id:option.value, option, ...option.dataset, options:JSON.parse(option.dataset.options)}));
      const optionInputs = [...form.querySelectorAll('[data-option-index]')];
      const add = section.querySelector('[data-pdp-add]');
      const sticky = section.querySelector('[data-pdp-sticky-add]');
      const buy = section.querySelector('[data-pdp-buy]');
      const offer = section.querySelector('[data-offer]');
      const stickyCompare = section.querySelector('[data-sticky-compare]');
      const qty = form.querySelector('[name="quantity"]');
      const unavailableLabel = section.querySelector('[data-unavailable-label]').textContent;
      const error = form.querySelector('[data-form-error]');
      let current = variants.find(variant => variant.id === select.value);
      let busy = false;
      const addon = form.querySelector('[data-addon-select]');
      const money = new Intl.NumberFormat(document.documentElement.lang === 'en' ? 'en-IN' : document.documentElement.lang, {style:'currency', currency:section.dataset.currency});
      function paintButtons() {
        const available = current?.variantAvailable === 'true';
        const label = busy ? section.querySelector('[data-adding-label]').textContent : !current ? unavailableLabel : available ? add.dataset.addLabel : add.dataset.soldOutLabel;
        add.disabled = sticky.disabled = busy || !available;
        add.textContent = sticky.textContent = label;
        if (buy) {buy.hidden = false;buy.disabled = busy || !available;buy.textContent = busy || !available ? label : buy.dataset.label;}
      }
      function updateAddon() {
        if (!addon) return;
        const selected = addon.selectedOptions[0];
        const enabled = Boolean(selected?.value);
        if (stickyCompare) stickyCompare.hidden = enabled || !current?.variantCompare;
        section.querySelector('[data-sticky-price]').textContent = current?.variantPrice || '—';
        section.querySelector('[data-sticky-variant]').textContent = current?.variantTitle || '';
        const panel = form.querySelector('[data-addon-panel]');
        panel.querySelector('[data-addon-preview]').hidden = !enabled;
        panel.querySelector('[data-addon-timing]').hidden = !enabled;
        panel.querySelector('[data-addon-total]').hidden = !enabled || !current;
        panel.querySelector('[data-gold-note]').hidden = !enabled || !selected.dataset.metal.includes('gold');
        const ring = panel.querySelector('[data-ring-size]');
        ring.hidden = !enabled || selected.dataset.wear !== 'ring';
        ring.querySelector('input').disabled = ring.hidden;
        if (enabled) {
          panel.querySelector('[data-addon-title]').textContent = selected.dataset.title;
          panel.querySelector('[data-addon-price]').textContent = selected.dataset.price;
          const slot = panel.querySelector('[data-addon-image-slot]');
          slot.replaceChildren();
          if (selected.dataset.image) {
            const photo = document.createElement('img');
            photo.src = selected.dataset.image; photo.alt = selected.dataset.title;
            photo.width = photo.height = 160; photo.loading = 'lazy'; slot.append(photo);
          }
          if (current) {
            const total = money.format((Number(current.priceCents) + Number(selected.dataset.priceCents))/100);
            panel.querySelector('[data-total-price]').textContent = total;
            section.querySelector('[data-sticky-price]').textContent = total;
            section.querySelector('[data-sticky-variant]').textContent = selected.dataset.title;
          }
        }
      }
      function updateAvailability() {
        const chosen = [];
        optionInputs.filter(input => input.checked).forEach(input => { chosen[Number(input.dataset.optionIndex)] = input.value; });
        optionInputs.forEach(input => {
          const index = Number(input.dataset.optionIndex);
          const match = variants.find(variant => variant.options.every((value,i) => value === (i === index ? input.value : chosen[i])));
          const status = input.closest('label').querySelector('[data-option-status]');
          status.textContent = !match ? unavailableLabel : match.variantAvailable === 'true' ? '' : add.dataset.soldOutLabel;
          input.closest('label').classList.toggle('pdp-option-unavailable', !match || match.variantAvailable !== 'true');
        });
      }
      function updateVariant(variant, updateUrl) {
        current = variant;
        if (offer) {
          const difference = Number(variant?.compareCents || 0) - Number(variant?.priceCents || 0);
          offer.hidden = !variant || difference <= 0;
          if (offer.hidden) offer.open = false;
          const badge = offer.querySelector('[data-offer-percent]');
          badge.textContent = difference > 0 ? badge.dataset.label.replace('[percent]',String(Math.floor(difference * 100 / Number(variant.compareCents)))) : '';
          offer.querySelector('[data-offer-saving]').textContent = variant?.variantSaving || '';
        }
        if (stickyCompare) {stickyCompare.textContent = variant?.variantCompare || '';stickyCompare.hidden = !variant?.variantCompare;}
        const photo = section.querySelector('.pdp-sticky-image');
        if (photo && variant?.variantImage) {photo.src = variant.variantImage;photo.removeAttribute('srcset');}

        select.value = variant?.id || '';
        select.disabled = !variant;
        section.querySelector('[data-current-price]').textContent = variant?.variantPrice || '—';
        section.querySelector('[data-sticky-price]').textContent = variant?.variantPrice || '—';
        section.querySelector('[data-sticky-variant]').textContent = variant?.variantTitle || '';
        section.querySelector('[data-selected-variant]').textContent = variant?.variantTitle || '';
        for (const [selector,key] of [['[data-compare-price]','variantCompare'],['[data-saving]','variantSaving']]) {
          const element = section.querySelector(selector); element.textContent = variant?.[key] || ''; element.hidden = !variant?.[key];
        }
        section.querySelector('[data-stock-status]').textContent = !variant ? unavailableLabel : variant.variantAvailable === 'true' ? section.querySelector('[data-available-label]').textContent : add.dataset.soldOutLabel;
        section.querySelector('[data-shipping-note]').hidden = !variant || variant.requiresShipping !== 'true';
        if (variant) {
          qty.min = variant.quantityMin || '1'; qty.step = variant.quantityStep || '1';
          if (variant.quantityMax) qty.max = variant.quantityMax; else qty.removeAttribute('max');
          qty.value = qty.min;
          if (updateUrl && variant.mediaId) move(slides.find(slide => slide.dataset.mediaId === variant.mediaId));
        }
        if (updateUrl) {
          const url = new URL(location.href);
          if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant');
          history.replaceState({},'',url);
        }
        error.hidden = true;
        updateAvailability(); updateAddon(); paintButtons();
      }
      form.addEventListener('change', event => {
        if (event.target.hasAttribute('data-option-index')) {
          const chosen = [];
          optionInputs.filter(input => input.checked).forEach(input => { chosen[Number(input.dataset.optionIndex)] = input.value; });
          updateVariant(variants.find(variant => variant.options.every((value,i) => value === chosen[i])),true);
        } else if (event.target === select) {
          const variant = variants.find(item => item.id === select.value);
          optionInputs.forEach(input => { input.checked = variant?.options[Number(input.dataset.optionIndex)] === input.value; });
          updateVariant(variant,true);
        } else if (event.target === addon) updateAddon();
      });
      form.addEventListener('submit', async event => {
        if (busy || !current || current.variantAvailable !== 'true') {event.preventDefault();return;}
        const buyNow = Boolean(event.submitter?.hasAttribute('data-pdp-buy'));
        if (!addon?.value && !buyNow) return;
        event.preventDefault();
        if (!form.reportValidity()) return;
        const selected = addon?.selectedOptions[0];
        if (addon?.value && (!selected || selected.disabled)) return;
        const properties = {};
        for (const [key,value] of new FormData(form)) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value.trim()) properties[match[1]] = value.trim();
        }
        const quantity = Number(qty.value);
        const items = [
          {id:Number(current.id), quantity, properties}
        ];
        if (selected?.value) items.push({id:Number(selected.value),quantity,properties:{...properties,_addon_for:current.id,_wear_type:selected.dataset.wear,_metal_type:selected.dataset.metal}});
        busy = true; error.hidden = true; paintButtons();
        try {
          const response = await fetch(section.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : section.querySelector('[data-cart-error-label]').textContent);
          location.assign(buyNow ? section.dataset.checkoutUrl : section.dataset.cartUrl);
        } catch (reason) {
          error.textContent = reason.message || section.querySelector('[data-cart-error-label]').textContent;
          error.hidden = false; busy = false; paintButtons();
        }
      });
      if (optionInputs.length) {
        form.querySelector('[data-option-groups]').hidden = false;
        form.querySelector('[data-native-selector]').hidden = true;
      }
      if (addon) form.querySelector('[data-addon-panel]').hidden = false;
      updateVariant(current,false);
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load',event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lca-product-row"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', event => {
    const filter = event.target.closest('.lca-editable-row [data-filter]');
    if (!filter) return;
    const section = filter.closest('.lca-editable-row');
    const value = filter.dataset.filter;
    let count = 0;
    section.querySelectorAll('[data-filter]').forEach(button => {
      const active = button === filter;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    section.querySelectorAll('.product-card').forEach(card => {
      const show = value === 'all' ? card.dataset.bestseller === 'true' : value === 'budget' ? Number(card.dataset.price) < 1000 : card.dataset.categories.split(' ').includes(value);
      card.hidden = !show;
      if (show) count++;
    });
    const status = section.querySelector('[data-filter-status]');
    if (status) status.textContent = count + ' · ' + filter.textContent;
    const empty = section.querySelector('[data-filter-empty]');
    if (empty) empty.hidden = count > 0;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
